// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');

const {
  CATEGORIES_TAB_SELECTOR_FETCHING,
  CATEGORIES_TAB_SELECTOR_SUCCESS,
  CATEGORIES_TAB_SELECTOR_FAILURE,
} = require('constants/actionTypes');

const requestCategoriesTabsFetching = () => {
  return {
    type: CATEGORIES_TAB_SELECTOR_FETCHING,
  };
};

const requestCategoriesTabsSuccess = response => {
  return {
    type: CATEGORIES_TAB_SELECTOR_SUCCESS,
    payload: {
      data: Array.isArray(response) ? response : [],
    },
  };
};

const requestCategoriesTabsFailure = () => {
  return {
    type: CATEGORIES_TAB_SELECTOR_FAILURE,
  };
};

const requestCategoriesTabs = filters => dispatch => {
  const url = apiURLBuilder.getURL('globalExpensesTotals');

  const requestData = {
    header: {
      version: 2,
    },
    query: {
      cards: filters.cards,
      ibans: filters.accounts,
      from: filters.fromDate,
      to: filters.toDate,
      banks: filters.banks,
    },
  };

  dispatch(requestCategoriesTabsFetching());

  return APIPost(dispatch, url, requestData).then(
    response => {
      dispatch(requestCategoriesTabsSuccess(response));
    },
    () => {
      dispatch(requestCategoriesTabsFailure());
    }
  );
};

module.exports = {
  requestCategoriesTabs,
};
